import EditFlowModal from 'components/RichProfile/EditMyProfile/Modals/EditFlowModal/EditFlowModal';
import { withEditFlowModalProps } from 'viewModel/richProfile/editMyProfile/modals/editFlowModal/withEditFlowModalProps';

const ConnectedEditFlowModal = withEditFlowModalProps(EditFlowModal);

export default ConnectedEditFlowModal;
